import { RouteName } from '~/common/models/route.model';

/**
 * Session flag written by business enrollment on `PREMATURE_ENROLLMENT_ERROR`.
 * Must match the key set in the enrollment app.
 */
export const PREMATURE_ENROLLMENT_STORAGE_KEY = 'PREMATURE_ENROLLMENT';

/**
 * True when this browser session was rejected for premature enrollment.
 * @returns Whether the session flag is set
 */
export const hasPrematureEnrollmentSession = (): boolean =>
  sessionStorage.getItem(PREMATURE_ENROLLMENT_STORAGE_KEY) === 'true';

/**
 * A user with no profile may stay on the migration-not-complete page only
 * after enrollment recorded a premature-enrollment error for this session.
 * @param routeName - Secure route being entered
 * @param profileId - Signed-in profile id, when one exists
 * @returns Whether the route should render without a profile
 */
export const canViewMigrationNotCompleteWithoutProfile = (
  routeName: RouteName | undefined,
  profileId: string | undefined
): boolean =>
  routeName === RouteName.MIGRATION_NOT_COMPLETE &&
  !profileId &&
  hasPrematureEnrollmentSession();
